import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-department-subject-mapping',
  templateUrl: './department-subject-mapping.component.html',
  styleUrls: ['./department-subject-mapping.component.scss']
})
export class DepartmentSubjectMappingComponent implements OnInit {
  deptSubMappingForm: FormGroup;
  CourseList: any;
  filteredListCourse: any;
  examList: any;
  filteredListExam: any;
  dialogRef: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  DepartmentList: any;
  filteredDepartmentList: any;
  subjectList: any;
  filteredsubjectList: any;
  SubCode: string;
  table = true;
  uncheckedSubjectList = [];
  checkedSubjectList = [];
  submitpayload: any;
  savedSubjects: any[] = [];  // holds previously saved subject data
  constructor(public fb: FormBuilder,
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    private httpClient: HttpClient,) { }
  searchTerm: string = '';
  ExamSubArray: FormArray;
  ngOnInit(): void {
    this.table = false;
    this.deptSubMappingForm = this.fb.group({
      DmId: new FormControl('', [Validators.required]),
      DmCoCode: new FormControl('', [Validators.required]),
      DmEmId: new FormControl(''),
      // DmEmSrNo: new FormControl('', [Validators.required]),
      DmSnNo: new FormControl(''),
      // practicalYN: new FormControl('', [Validators.required]),
      ExamSubArray: this.fb.array([]),
    });
    this.getDepartmentData();
    this.getCourse();
    // this.fetchSession();
    // this.fetchDeptSubjectData();
  }
  getDepartmentData() {
    this.spinner.show();
    const payload = {};
    this.table = false;
    this.deptSubMappingForm.controls['DmCoCode'].setValue('');
    // this.deptSubMappingForm.controls['DmEmId'].setValue('');
    // this.deptSubMappingForm.controls['DmEmSrNo'].setValue('');
    this.umsService.getDeptData(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.DepartmentList = res.data;
        this.filteredDepartmentList = this.DepartmentList.slice();
      } else {
        this.spinner.hide();
        this.DepartmentList = [];
        this.filteredDepartmentList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.DepartmentList = [];
    });
  }
  getCourse() {
    this.spinner.show();
    const payload = {};
    this.table = false;
    // this.deptSubMappingForm.controls['DmEmId'].setValue('');
    // this.deptSubMappingForm.controls['DmEmSrNo'].setValue('');
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }

  getExamList(e) {
    this.spinner.show();
    const payload = {};
    payload['EmCoCode'] = e;
    this.table = false;
    // this.deptSubMappingForm.controls['DmEmSrNo'].setValue('');
    // this.fetchDeptSubjectData();
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }

  fetchSrNo(item) {
    this.deptSubMappingForm.controls.DmEmSrNo
    this.deptSubMappingForm.controls['DmEmSrNo'].setValue(item.EmSrNo);
    this.fetchDeptSubjectData(item);
  }

  fetchSession() {
    this.spinner.show();
    const payload = {};
    this.table = false;
    this.deptSubMappingForm.controls['DmId'].setValue('');
    this.deptSubMappingForm.controls['DmCoCode'].setValue('');
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        this.spinner.hide();
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
  getControls() {
    return (this.deptSubMappingForm.get('ExamSubArray') as FormArray).controls;
  }
  getCourseSub(data) {
    // this.emid = 0;
    // this.Table = false;
    this.subjects(data.CoCode, 0)
  }

  subjects(CoCode, StrId) {
    this.spinner.show();
    this.table = true;
    this.SubCode = ''
    const payload = {};
    payload['CoCode'] = CoCode;
    this.umsService.getCoursewiseSub(payload).subscribe(res => {
      this.spinner.hide()
      this.subjectList = res.data;
      this.filteredsubjectList = this.subjectList.slice();
      const examSubArray = this.deptSubMappingForm.get('ExamSubArray') as FormArray;
      examSubArray.clear(); // Clear existing data
      this.subjectList.forEach(subject => {
        // const saved = this.savedSubjects.find(s => s.DmSubEsId === subject.EsId);
        const saved = this.savedSubjects.find(s => {
          return s.DmSubEsId.toString() === subject.EsId.toString();
        });
        examSubArray.push(this.fb.group({
          DmSubEsId: [subject.EsId],
          EsName: [subject.EsName],    
          DmEmSrNo: [subject.EmSrNo],
          subjectcheckbox: [!!saved], 
          practicalcheckbox: [{ value: false, disabled: true }], 
        }));
      });
    });
  }

  submit() {
    if (this.deptSubMappingForm.invalid) {
      this.deptSubMappingForm.get('DmId').markAsTouched();
      this.deptSubMappingForm.get('DmCoCode').markAsTouched();
      return;
    } else {
      this.addDeptSub();
    }
  }

  addDeptSub() {
    this.submitpayload = this.deptSubMappingForm.value;
    let examSubArray = this.deptSubMappingForm.get('ExamSubArray') as FormArray;

    let dmSubjects = examSubArray.value
      .filter(item => item.subjectcheckbox === true)
      .map(item => ({
        DmSubId: item.DmSubId, 
        DmId: this.submitpayload.DmId,
        DmCoCode: this.submitpayload.DmCoCode,
        DmEmId: this.submitpayload.DmEmId,
        DmEmSrNo: item.DmEmSrNo,
        DmSnNo: this.submitpayload.DmSnNo,
        DmSubEsId: item.DmSubEsId, 
        IsPractical: item.practicalcheckbox
      }));
    const finalPayload = {};
    finalPayload['LoginId'] = parseInt(sessionStorage.getItem('userId')),
      finalPayload['DmSubjects'] = dmSubjects,
    this.umsService.addDepartmentSub(finalPayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = 'Submitted Successfully'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    });
  }
  fetchDeptSubjectData(item) {
    this.spinner.show();
    const payload = {};
    payload['DeptCode'] = this.deptSubMappingForm.value.DmId,
      payload['CoCode'] = this.deptSubMappingForm.value.DmCoCode,
      payload['SnNo'] = this.deptSubMappingForm.value.DmSnNo,
      payload['EmId'] = this.deptSubMappingForm.value.DmEmId,
      // payload['EmSrNo'] = this.deptSubMappingForm.value.DmEmSrNo
      this.umsService.getDeptSubData(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.savedSubjects = Array.isArray(res) ? res : res.data || [];
        } else {
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
  }
  back() {
    this.reset();
    this.table = false;
  }
  reset() {
    this.deptSubMappingForm.get('DmId').reset();
    this.deptSubMappingForm.get('DmCoCode').reset();
  }
}
